import { useTranslation } from "../../../shared/hooks/useTranslation";

export const ShowFilterBtn = () => {
  const { t } = useTranslation();

  return (
    <div className="show-filter-btn-for-mobile">
      <img alt="funnel-icon" src="/assets/icons/Funnel.svg" />
      <div className="filter-tag-title">{t("filter.showKeywordFilter")}</div>
    </div>
  );
};
